import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';
import * as moment from 'moment';
import {EventDate} from "../../model";


@Directive({
  selector: '[appDateValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: DateValidatorDirective, multi: true }]
})
export class DateValidatorDirective implements Validator {

  @Input('appDateValidator') eventDates: Array<EventDate> | undefined;

  @Input() dateFormat: string = 'DD/MM/YYYY';


  validate(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null;
    }

    const newDate = moment(control.value, this.dateFormat, true);

    if (!newDate.isValid()) {
      return { 'invalidDate': true };
    }

    const isDuplicate = this.eventDates?.some(eventDate => {
      const existingDate = moment(eventDate.date, this.dateFormat, true);
      return existingDate.isValid() && newDate.isSame(existingDate, 'day');
    });

    if (isDuplicate) {
      return { 'duplicateDate': true };
    }

    return null;
  }
}
